import React, { useState } from 'react';
import { Tooltip } from 'antd';
import RenameModal from './RenameModal';
import { EditOutlined } from '@ant-design/icons';
import { MindMapContext } from '../../Context/contex';
import './styles.css';

const DocumentTitle = () => {
    const { documentInfo, templateData, isTemplateDocument, isReadOnly } = MindMapContext();
    const [renameModalVisible, setRenameModalVisible] = useState(false);
    const name = isTemplateDocument ? (templateData ? templateData.name : "Template") : (documentInfo ? documentInfo.name : "New Board");

    return (
        <>
            <div className="document-title-container">
                <h1 className="document-title-h1" title={name}>
                    {name}
                </h1>
                {!isReadOnly && (
                    <Tooltip title="Rename">
                        <button
                            type="button"
                            className="document-title-edit-icon"
                            onClick={() => setRenameModalVisible(true)}
                            aria-label="Rename"
                        >
                            <EditOutlined />
                        </button>
                    </Tooltip>
                )}
            </div>
            <RenameModal
                visible={renameModalVisible}
                onClose={() => setRenameModalVisible(false)}
            />
        </>
    );
};

export default DocumentTitle;
